import styled, { css } from 'styled-components'

type BannerSectionProps = {
  isHotsite?: boolean
  isCategory?: boolean
  swiperColor?: string
  darkTheme?: boolean
}

export const BannerSection = styled.section<BannerSectionProps>`
  position: relative;
  overflow: hidden;
  min-height: ${({ isCategory }) => (isCategory ? 'auto' : '472px')};
  max-width: ${({ isHotsite }) => (isHotsite ? '1300px' : '100%')};
  margin: auto;
  ${({ darkTheme }) =>
    darkTheme &&
    css`
      background-color: #141723 !important;
    `}
  .btn {
    position: absolute;
    z-index: 2;
    top: ${({ isCategory }) => (isCategory ? '40%' : '50%')};
    margin-top: -24px;
    cursor: pointer;
    transform: scale(1);
    transition: all 0.4s;
    &:hover {
      transform: scale(1.05);
      transition: all 0.4s;
    }
    &.swiper-button-disabled {
      opacity: 0.5;
    }

    &#btn-next-banner {
      right: 3em;
    }
    &#btn-prev-banner {
      left: 3em;
    }
  }
  .swiper-slide {
    width: 100%;
    height: ${({ isCategory }) => (isCategory ? '170px' : '472px')};
    transform: scale(1);
    transition: all 0.4s;
    &:hover {
      transform: scale(1.02);
      transition: all 0.4s;
    }
    a {
      display: block;
      width: 100%;
      height: 100%;
      max-width: 1920px;
      margin: 0 auto;
      position: relative;

      img {
        object-fit: ${({ isCategory }) => (isCategory ? 'fill' : 'cover')};
      }
    }

    .hotsite {
      display: block;
      width: 100%;
      height: 100%;
      max-width: 1920px;
      max-height: 650px;
      margin: 0 auto;
      position: relative;

      img {
        @media (min-width: 320px) and (max-width: 425px) {
          object-fit: unset;
        }
      }
    }
  }

  .swiper {
    margin-top: 0em;
    ${({ isHotsite }) =>
      isHotsite &&
      css`
        border-radius: 1rem !important;
      `}
  }

  .ctrl-slide {
    left: 0;
    bottom: 6px;
    z-index: 1;
    width: 100%;
    min-height: 41px;
    ${({ darkTheme }) =>
      darkTheme &&
      css`
        background-color: #141723 !important;
      `}
    .swiper-pagination {
      position: relative;
      bottom: 0;
      z-index: 1;
      .swiper-pagination-bullet {
        background-color: ${({ swiperColor }) => swiperColor || '#3399ff'};
        margin: 0px 6.5px;
        opacity: 0.4;
        transition: all 0.3s;
        width: 17px;
        height: 4px;
        display: inline-block;
        border-radius: 2px;
        opacity: 0.2;
        &.swiper-pagination-bullet-active {
          opacity: 1;
          transition: all 0.3s;
        }
      }
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }

  @media (min-width: 1065px) and (max-width: 1200px) {
    margin: -0.1em 0 1em 0;
    min-height: 471px;

    :has(.hotsite) {
      min-height: 450px;
    }

    .swiper-slide {
      background-size: cover;
      height: 410px;

      :has(.hotsite) {
        height: 380px;
      }
    }
    .swiper {
      margin-top: 1.5rem;
      border-radius: 15px;
      margin-left: 1.3rem;
      margin-right: 1.3rem;
    }
    .btn {
      display: none;
    }
    .ctrl-slide {
      position: absolute;
      bottom: 0;
      margin: 0;
    }
  }

  @media (min-width: 910px) and (max-width: 1064px) {
    margin: -0.1em 0 1em 0;
    min-height: 471px;

    :has(.hotsite) {
      min-height: 600px;
    }

    .swiper-slide {
      background-size: cover;
      height: 410px;

      :has(.hotsite) {
        height: 550px;
      }
    }
    .swiper {
      margin-top: 1.5rem;
      border-radius: 15px;
      margin-left: 1.3rem;
      margin-right: 1.3rem;
    }
    .btn {
      display: none;
    }
    .ctrl-slide {
      position: absolute;
      bottom: 0;
      margin: 0;
    }
  }

  @media (min-width: 800px) and (max-width: 910px) {
    margin: -0.1em 0 1em 0;
    min-height: 471px;

    :has(.hotsite) {
      min-height: 525px;
    }

    .swiper-slide {
      background-size: cover;
      height: 410px;

      :has(.hotsite) {
        height: 440px;
      }
    }
    .swiper {
      margin-top: 1.5rem;
      border-radius: 15px;
      margin-left: 1.3rem;
      margin-right: 1.3rem;
    }
    .btn {
      display: none;
    }
    .ctrl-slide {
      position: absolute;
      bottom: 0;
      margin: 0;
    }
  }
  @media (min-width: 600px) and (max-width: 800px) {
    margin: -0.1em 0 1em 0;
    min-height: 371px;

    :has(.hotsite) {
      min-height: 490px;
    }

    .swiper-slide {
      background-size: cover;
      height: 310px;

      :has(.hotsite) {
        height: 435px;
      }
    }
    .swiper {
      margin-top: 1.5rem;
      border-radius: 6px;
      margin-left: 1.3rem;
      margin-right: 1.3rem;
    }
    .btn {
      display: none;
    }
    .ctrl-slide {
      position: absolute;
      bottom: 0;
      margin: 0;
    }
  }
  @media (min-width: 491px) and (max-width: 520px) {
    :has(.hotsite) {
      min-height: 290px;
    }

    .swiper-slide {
      background-size: cover;
      height: 240px;

      :has(.hotsite) {
        height: 220px;
      }
    }
    .swiper {
      margin-top: 1.5rem;
      border-radius: 6px;
      margin-left: 1.3rem;
      margin-right: 1.3rem;
    }
    .btn {
      display: none;
    }
    .ctrl-slide {
      position: absolute;
      bottom: 0;
      margin: 0;
    }
  }
  @media (min-width: 601px) and (max-width: 768px) {
    margin-top: -0.1em;
    min-height: 301px;

    :has(.hotsite) {
      min-height: 420px;
    }

    .swiper-slide {
      background-size: cover;
      height: 240px;

      :has(.hotsite) {
        height: 350px;
      }
    }

    .swiper {
      margin-top: 1.5rem;
      border-radius: 6px;
      margin-left: 1.3rem;
      margin-right: 1.3rem;
    }
    .btn {
      display: none;
    }
    .ctrl-slide {
      position: absolute;
      bottom: 0;
      margin: 0;
    }
  }
  @media (min-width: 520px) and (max-width: 600px) {
    margin-top: -0.1em;
    min-height: 301px;

    :has(.hotsite) {
      min-height: 340px;
    }

    .swiper-slide {
      background-size: cover;
      height: 240px;

      :has(.hotsite) {
        height: 280px;
      }
    }

    .swiper {
      margin-top: 1.5rem;
      border-radius: 6px;
      margin-left: 1.3rem;
      margin-right: 1.3rem;
    }
    .btn {
      display: none;
    }
    .ctrl-slide {
      position: absolute;
      bottom: 0;
      margin: 0;
    }
  }
  @media (min-width: 390px) and (max-width: 490px) {
    margin-top: -0.1em;
    min-height: 241px;

    :has(.hotsite) {
      min-height: 250px;
    }

    .swiper-slide {
      background-size: cover;
      height: 190px;
    }
    .swiper {
      margin-top: ${({ darkTheme }) => (darkTheme ? '0.5rem' : '1.5rem')};
      border-radius: 6px;
      margin-left: 1.3rem;
      margin-right: 1.3rem;
    }
    .btn {
      display: none;
    }
    .ctrl-slide {
      position: absolute;
      bottom: 0;
      margin: 0;
    }
  }
  @media (min-width: 330px) and (max-width: 390px) {
    margin-top: -0.1em;
    min-height: 240px;

    .swiper {
      margin-top: 1.5rem;
      border-radius: 6px;
      margin-left: 1.3rem;
      margin-right: 1.3rem;
    }
    .swiper-slide {
      background-size: cover;
      height: 176px;
    }
    .btn {
      display: none;
    }
    .ctrl-slide {
      position: absolute;
      bottom: 0;
      margin: 0;
    }
  }
  @media (min-width: 290px) and (max-width: 330px) {
    margin-top: -0.1em;
    min-height: 240px;
    .swiper {
      margin-top: 1.5rem;
      border-radius: 6px;
      margin-left: 1.3rem;
      margin-right: 1.3rem;
    }
    .swiper-slide {
      background-size: cover;
      height: 176px;
    }

    .btn {
      display: none;
    }
    .ctrl-slide {
      position: absolute;
      bottom: 0;
      margin: 0;
    }
  }
  @media (max-width: 290px) {
    margin-top: -0.1em;
    min-height: 240px;
    .swiper {
      margin-top: 1.5rem;
      border-radius: 6px;
      margin-left: 1.3rem;
      margin-right: 1.3rem;
    }
    .swiper-slide {
      background-size: cover;
      height: 176px;
    }
    .btn {
      display: none;
    }
    .ctrl-slide {
      position: absolute;
      bottom: 0;
      margin: 0;
    }
  }
`

type SwiperPaginationContainerProps = {
  isHotsite?: boolean
}

export const SwiperPaginationContainer = styled.div<SwiperPaginationContainerProps>`
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  max-width: 1310px;
  padding: 0 15px;
  width: 100%;

  @media (max-width: 30rem) {
    margin-top: 1rem;
  }
`
